import { render, staticRenderFns } from "./ThemeSettingsDirectTop.vue?vue&type=template&id=1c1246f8&scoped=true"
import script from "./ThemeSettingsDirectTop.vue?vue&type=script&lang=js"
export * from "./ThemeSettingsDirectTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1246f8",
  null
  
)

export default component.exports